// React
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Material UI
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';

// Components
import Select from '@components/atoms/Select/Select';
import Button from '@components/atoms/Button/Button';

// Redux
import { connect, useDispatch } from 'react-redux';

// Services
import { fetchIndicatorTemplateList as fetchIndicatorTemplatesService } from '@services/indicatorTemplateServices';
import { fetchIndicatorTemplateGroupList } from '@services/indicatorTemplateGroupServices';

/**
 * Dialog to select and add an indicator template to a program.
 */
const ProgramIndicatorTemplateDialog = ({
  open,
  onClose,
  onConfirm,
  templates,
  fetchTemplates,
}) => {
  const dispatch = useDispatch();
  const [templatesList, setTemplatesList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    if (open) {
      fetchTemplates().then((res) => {
        const list = (res && res.data) || res || [];
        setTemplatesList(list);
      });
      dispatch(fetchIndicatorTemplateGroupList()).then((res) => {
        const list = (res && res.data) || res || [];
        setGroups(list);
      });
    }
  }, [open]);

  const handleConfirm = () => {
    let selection = null;
    if (selectedTemplate) {
      selection = { type: 'template', id: selectedTemplate };
    } else if (selectedGroup) {
      selection = { type: 'group', id: selectedGroup };
    }
    if (selection) {
      onConfirm(selection);
      onClose();
    }
  };

  console.log(templates);

  const options = templates.map((t) => ({ value: t.id, name: t.name }));

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Dodaj wskaźnik z szablonu</DialogTitle>
      <DialogContent>
        <Select
          label="Wzorzec wskaźnika"
          data={templatesList.map((t) => ({ value: t.id, name: t.indicator_name || t.name }))}
          text="name"
          selectValue={selectedTemplate}
          onChange={(_e, value) => {
            setSelectedTemplate(value);
            setSelectedGroup(null);
          }}
          fullWidth
        />
        <Select
          label="Grupa wzorców wskaźników"
          data={groups.map((g) => ({ value: g.id, name: g.name }))}
          text="name"
          selectValue={selectedGroup}
          onChange={(_e, value) => {
            setSelectedGroup(value);
            setSelectedTemplate(null);
          }}
          fullWidth
          style={{ marginTop: '1rem' }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Anuluj</Button>
        <Button onClick={handleConfirm} disabled={!(selectedTemplate || selectedGroup)} variant="contained" color="primary">
          Dodaj
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ProgramIndicatorTemplateDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  templates: PropTypes.arrayOf(PropTypes.any),
  fetchTemplates: PropTypes.func,
};

ProgramIndicatorTemplateDialog.defaultProps = {
  templates: [],
  fetchTemplates: null,
};

const mapStateToProps = (state) => ({
  templates: state.indicatorTemplateReducer.templates,
});

const mapDispatchToProps = (dispatch) => ({
  fetchTemplates: () => dispatch(fetchIndicatorTemplatesService()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProgramIndicatorTemplateDialog);
